import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function AdminReset() {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/admin/reset-password", { token, password: pw });
      setDone(true);
      toast.success("Password updated. You can now sign in.");
    } catch (err) {
      toast.error((err && err.response && err.response.data && err.response.data.detail) || "Could not reset password. The link may have expired.");
    }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="admin-reset">
      <div className="c4t-card">
        <h1 className="text-3xl font-['Fredoka'] font-bold">Reset Admin Password</h1>
        {!token && <p className="c4t-desc mt-2 text-[#e63946]">This reset link is missing its token. Please open the link from your email.</p>}
        {done ? (
          <div className="mt-4">
            <p className="c4t-desc">Your password has been updated.</p>
            <button onClick={() => nav("/admin")} className="c4t-btn c4t-btn-pink w-full mt-4">Go to admin sign in</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-4">
            <label className="text-sm font-bold">New password</label>
            <input type="password" className="c4t-input mt-1" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} required />
            <label className="text-sm font-bold mt-3 block">Confirm new password</label>
            <input type="password" className="c4t-input mt-1" placeholder="Confirm new password" value={pw2} onChange={(e) => setPw2(e.target.value)} required />
            <button type="submit" disabled={busy || !token} className="c4t-btn c4t-btn-pink w-full mt-4" data-testid="admin-reset-btn">{busy ? "Saving..." : "Set new password"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
